const default_no_avatar = [/hubfs\/defaults\/contact\.png/, /hubfs\/defaults\/company\.png/, /avatar\/hash\/4bd0df0db6227e87de4031baa4422b73/, /avatar\/hash\/cc7a027acb4f854bd9b1d3a511d1740c/, /avatar\/hash\/5be48140e95ae69927946a77d6c29d1a/, /avatars\.s3\.amazonaws\/default-100/, /hubspot-avatars\.s3\.amazonaws\.com\/default-100/, /default-avatars\/default-contact-.*.png/];
export function getAvatarSrc({
  avatarURI,
  error,
  loaded,
  src
}) {
  if (src) {
    return src;
  }
  if (avatarURI) {
    if (avatarURI && loaded && !error && default_no_avatar.filter(regex => regex.test(avatarURI)).length > 0) {
      return undefined;
    } else if (avatarURI && loaded && !error) {
      return avatarURI;
    }
  }
  return undefined;
}